import React from 'react';
import { useNavigate } from 'react-router-dom';
import NotFoundComponent from '../../components/NotFound';

function NotFound() {
  const navigate = useNavigate();

  return (
    <NotFoundComponent
      details='The page you are looking for was moved, removed or might have never existed.'
      buttonText='Back to the Home Page'
      navigate={() => navigate('/')}
    />
  );
}

export default NotFound;
